import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Este eBook es para mí?',
  answer: 'Sí, está dirigido a personas que viven con estrés constante, duermen mal o no logran recuperarse al descansar y desean incorporar hábitos prácticos para mejorar su bienestar.'
}, {
  question: '¿Cuándo recibiré la guía?',
  answer: 'Inmediatamente después de completar el pago recibirás el acceso para descargar el eBook y comenzar cuando lo desees.'
}, {
  question: '¿Necesito conocimientos previos?',
  answer: 'No. La guía está escrita en un lenguaje sencillo y explica cada paso de forma clara y práctica.'
}, {
  question: '¿Es un tratamiento médico?',
  answer: 'No. Es una guía educativa basada en hábitos saludables. No sustituye el diagnóstico, tratamiento o seguimiento de un profesional de la salud.'
}, {
  question: '¿En qué dispositivos puedo leerla?',
  answer: 'Puedes leerla en tu teléfono, tableta o computadora cuando quieras.'
}, {
  question: '¿Cómo se realiza el pago?',
  answer: 'El pago se procesa de forma segura a través de Hotmart, una plataforma reconocida internacionalmente para la venta de productos digitales.'
}];
export const FaqSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 lg:py-28 bg-brand-lightmint" data-id="element-14">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-17">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} data-id="element-19">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-20">
                  <span className="font-bold text-brand-charcoal pr-4" data-id="element-21">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="flex-shrink-0" data-id="element-22">
                    <ChevronDown className="w-5 h-5 text-brand-emerald" data-id="element-23" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-24">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-25">
                      <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-26">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
};